import {toast} from '@utils/dlg'
import {PAGE_SAVE} from '@store/mutation-types'

class Pager {
  constructor (count) {
    this.total = 0
    this.count = count
    this.page = 1
  }

  addPage (page = 1) {
    this.page += page
    return this
  }

  subPage (page = 1) {
    if (this.page - page > 0) this.page -= page
    return this
  }

  get params () {
    return {
      page: this.page,
      count: this.count
    }
  }
}

export {
  errorFn,
  Pager,
  loginRouteGo,
  setLoginRoute
}

function errorFn (error) {
  if (error) {
    toast.e(error.message)
  } else {
    console.log('error', error)
  }
}

function loginRouteGo (route) {
  let localState = localStorage.getItem(PAGE_SAVE)
  let state = localState || '123'
  let goRoute = ''
  switch (state) {
    case '123':
      goRoute = 'Main'
      break
    case '124':
      goRoute = 'UserInfo'
      break
    default:
      goRoute = 'Main'
  }
  localStorage.removeItem(PAGE_SAVE)
  route.push({name: goRoute})
}

function setLoginRoute (routeName) {
  localStorage.removeItem(PAGE_SAVE)
  let state = ''
  switch (routeName) {
    case 'Main':
      state = '123'
      break
    case 'UserInfo':
      state = '124'
      break
    default:
      state = '123'
  }
  localStorage.setItem(PAGE_SAVE, state)
}



// WEBPACK FOOTER //
// ./src/utils/api.js